<!-- eslint-disable prefer-const -->
<!-- eslint-disable vue/no-v-html -->
<script>
import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
  name: "MessageRichArea",
  model: {
    prop: "modelValue",
    event: "on-change-model-value",
  },
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    insertArguments: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
      default: 120,
    },
  },
  setup(props, { refs, emit }) {
    const containerStyle = computed(() => ({
      minHeight: `${props.height}px`,
    }));

    const cursorVariables = {
      baseOffset: 0,
      anchorNode: "",
    };

    // 将光标移到后面
    const removeCursorToBack = () => {
      refs.htmlContentRef.focus();
      const range = window.getSelection();
      range.selectAllChildren(refs.htmlContentRef);
      range.collapseToEnd();
    };

    // 点击父盒子输入框获取焦点
    const onclickBox = () => {
      // removeCursorToBack();
      // const content = refs.htmlContentRef.innerHTML;
      // if (content.substring(content.length - 6) !== "&nbsp;") {
      //   refs.htmlContentRef.innerHTML = `${content}&nbsp;`;
      // }
    };

    // 根据位置替换字符串
    const insertStr = (source, start, newStr) =>
      source.slice(0, start) + newStr + source.slice(start);

    // 点击插入参数的菜单项
    const handleClickMenu = async (val) => {
      const tagHtml = `<span class="insert-argument" contenteditable="false">${val.key}</span>`;
      let content = refs.htmlContentRef.innerHTML;

      let { baseOffset, anchorNode } = cursorVariables;
      if (!anchorNode?.data?.trim() || !content) {
        content += tagHtml;
      } else {
        let anchorText = anchorNode.data.replace('"', "").replace('"', "");
        const trimAnchorText = anchorText.trim();
        let newAnchorNode = insertStr(anchorText, baseOffset, tagHtml);
        content = content.replace(trimAnchorText, newAnchorNode);
      }

      refs.htmlContentRef.innerHTML = `${content}&nbsp;`;
      // refs.htmlContentRef.innerHTML = `${content} `;
      removeCursorToBack();
      emit("on-change-model-value", content);
      refs.htmlContentRef.focus();
    };

    // 输入内容改变事件
    const handleInputChange = () => {
      const content = refs.htmlContentRef.innerHTML;
      emit("on-change-model-value", content);
    };

    // 重置输入数据
    const rest = () => {
      refs.htmlContentRef.innerHTML = "";
    };

    // 设置默认值
    const setValue = (val) => {
      refs.htmlContentRef.innerHTML = `${val}&nbsp;`;
    };

    // 鼠标移入到插入参数按钮上面时记录一下当前光标所在位置
    const handleMouseover = () => {
      cursorVariables.baseOffset = window.getSelection().baseOffset;
      cursorVariables.anchorNode = window.getSelection().anchorNode;
    };

    // 监听删除事件
    const handleKeyupDelete = (event) => {
      let lastNode = refs.htmlContentRef.lastChild;

      if (lastNode?.nodeType === Node.ELEMENT_NODE) {
        event.preventDefault();
        refs.htmlContentRef.removeChild(lastNode);
      }
    };

    // 向光标所在位置插入html
    const insertHtml = (html) => {
      let sel; let range;
      sel = window.getSelection();
      if (sel.getRangeAt && sel.rangeCount) {
        range = sel.getRangeAt(0);
        range.deleteContents();
        let el = document.createElement("div");
        el.innerHTML = html;
        let frag = document.createDocumentFragment();
          let node;
          let lastNode;
        // eslint-disable-next-line no-cond-assign
        while ((node = el.firstChild)) {
          lastNode = frag.appendChild(node);
        }
        range.insertNode(frag);
        if (lastNode) {
          range = range.cloneRange();
          range.setStartAfter(lastNode);
          range.collapse(true);
          sel.removeAllRanges();
          sel.addRange(range);
        }
      }
    }

    // 监听回车事件
    const handleKeydownEnter = (event) => {
      event.preventDefault();
      insertHtml("</br>&emsp;");
      // document.execCommand("insertHTML", false, "</br>&emsp;");
    };

    return {
      containerStyle,
      onclickBox,
      handleClickMenu,
      handleInputChange,
      handleMouseover,
      rest,
      setValue,
      handleKeyupDelete,
      handleKeydownEnter,
    };
  },
});
</script>

<template>
  <div class="message-rich-area">
    <div class="container" :style="containerStyle" @click.self="onclickBox">
      <span
        ref="htmlContentRef"
        class="html-content"
        contenteditable
        @input="handleInputChange"
        @keydown.delete="handleKeyupDelete"
        @keydown.enter="handleKeydownEnter"
      ></span>
      <a-dropdown>
        <span class="link" @mouseover="handleMouseover">插入参数</span>
        <a-menu slot="overlay" @click="handleClickMenu">
          <a-menu-item v-for="item in insertArguments" :key="item">{{ item }}</a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<style lang="less" scoped>
.container {
  width: 100%;
  box-sizing: border-box;
  background-color: white;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  text-align: left;
  padding: 6px;
  word-wrap: break-word;
  overflow: hidden;
  transition: all 0.3s;

  &:hover {
    border-color: #40a9ff;
  }

  .html-content {
    line-height: 24px;
    word-break: break-all;
    // -webkit-user-modify: read-write-plaintext-only;
  }
}

.input {
  border: none;
  box-shadow: none;
  outline: none;
  background-color: transparent;
  padding: 0;
  width: 4px;
  vertical-align: top;
  color: #495060;
  line-height: 24px;
  height: 24px;
}

.link {
  color: #06b880;
  cursor: pointer;
  margin-left: 14px;
  white-space: nowrap;
}
</style>

<style>
.insert-argument {
  color: #fff;
  display: inline-block;
  border-radius: 4px;
  margin-right: 2px;
  font-size: 12px;
  padding: 0 6px;
  line-height: 22px;
  margin: 0 6px;
  background-color: rgb(16, 142, 233);
}
</style>
